import { useEffect, useMemo, useState } from 'react';

export const useCountdown = (date: string) => {
  const [secondsLeft, setSecondsLeft] = useState(1);

  useEffect(() => {
    const now = Date.now();
    const ticketingStart = new Date(date).getTime();

    if (now < ticketingStart) {
      const interval = setInterval(() => {
        const diff = ticketingStart - Date.now();
        if (diff <= 0) {
          clearInterval(interval);
          setSecondsLeft(0);
        } else {
          setSecondsLeft(Math.floor(diff / 1000));
        }
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    } else {
      setSecondsLeft(0);
    }
  }, [date]);

  const timeLeft = useMemo(() => {
    if (secondsLeft === 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    const days = Math.floor(secondsLeft / 86400);
    const hours = Math.floor((secondsLeft % 86400) / 3600);
    const minutes = Math.floor((secondsLeft % 3600) / 60);
    const seconds = secondsLeft % 60;

    return { days, hours, minutes, seconds };
  }, [secondsLeft]);

  return { secondsLeft, timeLeft };
};
